function scrollElementIntoViewByRef(element, offset = 0) {
  const y =
    element.value.getBoundingClientRect().top + window.pageYOffset + offset;

  window.scrollTo({ top: y, behavior: "smooth" });
}

export { scrollElementIntoViewByRef };
